/* PackageDetailsRenderer.js */

"use strict";

const localTime = require("../../../../../lib/LocalTime");

class PackageDetailsRenderer {
    constructor(model) {
        this._model = model;
        this._rootElem = document.createElement("package-details");
        this._rootElem.component = this._model;

        this._registerListeners();
    }
    /********************************************/
    /* START PRIVATE COMPONENT RENDERER METHODS */
    /********************************************/
    _shutdown() {
        let prom = new Promise((resolve /*,reject*/) => {
            this._unregisterListeners();
            this._model = undefined;
            this._rootElem.remove();
            this._rootElem = undefined;
            //TODO set all class members to undefined here
            resolve();
        });
        return prom;
    }
    _registerListeners() {
        this._model.on("Shutdown", (this._onShutdown = this._onShutdown.bind(this)));
        this._model.on(
            "DetailsReplaced",
            (this._onDetailsReplaced = this._onDetailsReplaced.bind(this))
        );
    }
    _unregisterListeners() {
        this._model.removeListener("Shutdown", this._onShutdown);
        this._model.on("DetailsReplaced", this._onDetailsReplaced);
    }
    /*******************************************/
    /* END PRIVATE COMPONENT RENDERER METHODS  */
    /* START PUBLIC COMPONENT RENDERER METHODS */
    /*******************************************/
    /**
     * Stateless method to completely rebuild this component from the _rootElem down.
     * @returns {Promise} An ES6 promise that lets the caller know when the component has finished rendering. If a non
     * Promise is returned the caller will assume the Renderer has completed rendering.
     */
    render() {
        this._rootElem.innerHTML = `
            <div class="detail_info pkg_name">
                <label class="bold">Name: </label>
                <span>${this._model.name}</span>
            </div>
            <div class="detail_info pkg_version">
                <label class="bold">Version: </label>
                <span>${this._model.version}</span>
            </div>
            <div class="detail_info pkg_description">
                <label class="bold">Description: </label>
                <pre>${this._model.description}</pre>
            </div>
            <div class="detail_info pkg_release_notes">
                <label class="bold">Release Notes: </label>
                <pre>${this._model.releaseNotes}</pre>
            </div>
        `;
        if (this._model.createUser) {
            this._rootElem.innerHTML += `
                <div class="detail_info pkg_release_notes">
                    <label class="bold">Installed By: </label>
                    <pre>${this._model.createUser}</pre>
                </div>
            `;
        }
        if (this._model.createTime) {
            this._rootElem.innerHTML += `
                <div class="detail_info pkg_release_notes">
                    <label class="bold">Installed On: </label>
                    <pre>${localTime(this._model.createTime * 1000)}</pre>
                </div>
            `;
        }
        return Promise.resolve();
    }
    get rootElement() {
        return this.getRootElement();
    }
    getRootElement() {
        return this._rootElem;
    }
    get model() {
        return this.getModel();
    }
    getModel() {
        return this._model;
    }
    /*******************************************/
    /* END COMPONENT RENDERER METHODS */
    /* START HANDLER METHODS */
    /*******************************************/
    _onShutdown() {
        this._shutdown();
    }
    _onDetailsReplaced() {
        this.render();
    }
    /*******************************************/
    /* END HANDLER METHODS */
    /* START PRIVATE API METHODS */
    /*******************************************/
    //TODO - Nobody should be using methods on a Renderer directly so make all these methods private
    /*******************************************/
    /*  END PRIVATE API METHODS */
    /*******************************************/
}
module.exports = PackageDetailsRenderer;
